import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const fetchListingSlice = createApi({
  reducerPath: "fetchListingThunk",
  baseQuery: fetchBaseQuery({
    baseUrl:
      "https://firestore.googleapis.com/v1/projects/clone-realtor-557bf/databases/(default)/documents",
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    }
  }),
  tagTypes: ["allListings"],
  endpoints: (builder) => ({
    getUserListings: builder.query({
      query: (uid: string) => ({
        url: ":runQuery",
        method: "POST",
        body: {
          structuredQuery: {
            from: [{ collectionId: "allListings" }],
            where: {
              fieldFilter: {
                field: { fieldPath: "uid" },
                op: "EQUAL",
                value: { stringValue: uid }
              }
            }
          }
        }
      }),
      providesTags: ["allListings"],
      transformResponse: (response: any) => {
        return response
          .filter((doc: any) => doc.document)
          .map((doc: any) => ({
            id: doc.document.name.split("/").pop(),
            ...Object.fromEntries(
              Object.entries(doc.document.fields).map(([k, v]: any) => [
                k,
                Object.values(v)[0]
              ])
            )
          }));
      }
    })
  })
});

export const { useGetUserListingsQuery } = fetchListingSlice;
